import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Input, Form, Button } from "reactstrap";
import { wglcsApiService } from "../../services/WglcsApiService";
import history from "../../app/history";
import "./Login/login.css";
import { DetectEnvironment } from "../../EnvironmentSettings";
import { utils } from "../../utils";
import MainLogo from "./SignUpScreens/MainLogo";

const ForgotPassword: React.FC = (props: any) => {
    const [email, setEmail] = React.useState<string>("");
    const [link, setLink] = React.useState<boolean>(false);
    const [navigatescreen, setNavigateScreen] = React.useState(false);
    const [emailErrorempty, setEmailErrorEmpty] = React.useState<string>("");
    const [count, setCount] = React.useState(0);

    useEffect(() => {
        window.addEventListener('keydown', onEnterBtn);
        return () => {
            window.removeEventListener('keydown', onEnterBtn);
        };
    }, [email]);

    const onEnterBtn = (e) => {
        if (e.key?.toString() === 'Enter') {
            e.preventDefault()
            registerMail()
        }
    }


    const registerMail = async () => {
        var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (email !== "") {
            if (emailRegex.test(email)) {
                const res = await wglcsApiService.forgotPassword(email);
                if(res.status === 200 && res.data.data === "NO record were found whith provided email address!"){
                    setEmailErrorEmpty(`${res.data.data.toString()}`);
                    return;
                }
                setLink(true);
                setEmailErrorEmpty("");
                setNavigateScreen(true);
            } else {
                setLink(false);
                setEmailErrorEmpty("Invalid Email Format");
            }
        } else {
            setLink(false);
            setEmailErrorEmpty("Please Enter Email");
            setNavigateScreen(false);
        }
    }
    const checkValidEmail = (value) => {
        setEmailErrorEmpty("");
        // var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        setEmail(value);
        // if (value?.toString() === "") {
        //     setEmailErrorEmpty("Please Enter Email");
        // } else if (!emailRegex.test(value)) {
        //     setEmailErrorEmpty("Invalid Email Format");
        // } else {
        //     setEmailErrorEmpty("");
        // }
    };

    const renderPrivacyPolicy = () => {
        if (DetectEnvironment.config.REACT_APP_PRIVACY_POLICY != "") {
            return <>| <a className="privacy-policy" target="_blank" href={DetectEnvironment.config.REACT_APP_PRIVACY_POLICY}>Privacy Policy</a></>
        }

        return ""
    }

    const BackToSignIn = () => {
        history.push("/")
        window.location.reload();
    }
    return (
        <div className={DetectEnvironment.config.REACT_APP_BG_IMAGE_STYLE}>
            <div className="login-box">
                <MainLogo />

                {!navigatescreen && (
                    <div className="forget-pw">
                        <div className="login-head">
                            <h2>Forgot your password?</h2>
                            <p>We'll help you to reset it and get back on track.</p>
                        </div>
                        <Form>
                            <div className="form-group">
                                <img
                                    className="login-input-image"
                                    title="Email"
                                    src={process.env.PUBLIC_URL + "/css/resources-images/email.svg"}
                                    alt=""
                                />
                                <Input
                                    type="email"
                                    className="login-input"
                                    name="inputEmail"
                                    id="inputEmail"
                                    placeholder="Email Address"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                />
                                <span className="error-message">{emailErrorempty}</span>
                            </div>
                            <div className="form-group">
                                {link ? <span className="success-message">Link has been sent to your email address!</span> :
                                    <Button onClick={() => registerMail()} className="signin-btn" block>
                                        Reset Password
                                    </Button>
                                }
                            </div>
                        </Form>

                        <div className="forget-password">
                            <NavLink to="/">Return to log in</NavLink>
                        </div>
                    </div>
                )}

                {navigatescreen && (
                    <div className="check-inbox">
                        <div className="login-head">
                            <h2>Check your inbox</h2>
                            <p>
                                We've sent a reset link to your inbox.
                                <br />
                                If it doesn't show up soon, check your spam folder.
                            </p>
                        </div>
                        <Form>
                            {count === 0 ? (
                                <div className="forget-password">
                                    <span
                                        className="resend-email"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            registerMail();
                                            setCount(count + 1);
                                        }}
                                    >
                                        Resend email
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}

                            <div className="form-group">
                                <Button onClick={() => BackToSignIn()} className="signin-btn">
                                    Back to Sign in
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
            <span className="copy-right">© {new Date().getFullYear()} {DetectEnvironment.config.REACT_APP_COPYRIGHT} {renderPrivacyPolicy()}</span>
            {!utils.isThisMobileDevice() && <span className="version">Version {process.env.REACT_APP_VERSION}</span>}
        </div>
    );
};

export default ForgotPassword;
